import * as React from 'react';
import * as styles from './CountrySelect.module.scss';

export const countries = [
  {
    value: 'https://flatfy.az',
    name: 'Azerbaijan'
  },
  {
    value: 'https://flatfy.by',
    name: 'Belarus'
  },
  {
    value: 'https://bg.flatfy.com',
    name: 'Bulgaria'
  },
  {
    value: 'https://flatfy.cl',
    name: 'Chile'
  },
  {
    value: 'https://flatfy.cz',
    name: 'Czech Republic'
  },
  {
    value: 'https://flatfy.ee',
    name: 'Estonia'
  },
  {
    value: 'https://flatfy.ge',
    name: 'Georgia'
  },
  {
    value: 'https://flatfy.gr',
    name: 'Greece'
  },
  {
    value: 'https://hu.flatfy.com',
    name: 'Hungary'
  },
  {
    value: 'https://flatfy.in',
    name: 'India'
  },
  {
    value: 'https://flatfy.id',
    name: 'Indonesia'
  },
  {
    value: 'https://flatfy.kz',
    name: 'Kazakhstan'
  },
  {
    value: 'https://flatfy.kg',
    name: 'Kyrgyzstan'
  },
  {
    value: 'https://flatfy.lv',
    name: 'Latvia'
  },
  {
    value: 'https://flatfy.lt',
    name: 'Lithuania'
  },
  {
    value: 'https://flatfy.my',
    name: 'Malaysia'
  },
  {
    value: 'https://flatfy.md',
    name: 'Moldova'
  },
  {
    value: 'https://flatfy.ng',
    name: 'Nigeria'
  },
  {
    value: 'https://flatfy.ph',
    name: 'Philippines'
  },
  {
    value: 'https://flatfy.pl',
    name: 'Poland'
  },
  {
    value: 'https://flatfy.ro',
    name: 'Romania'
  },
  {
    value: 'https://flatfy.sk',
    name: 'Slovakia'
  },
  {
    value: 'https://flatfy.si',
    name: 'Slovenia'
  },
  {
    value: 'https://flatfy.co.za',
    name: 'South Africa'
  },
  {
    value: 'https://flatfy.ua',
    name: 'Ukraine'
  },
  {
    value: 'https://flatfy.ae',
    name: 'United Arab Emirates'
  },
  {
    value: 'https://flatfy.uz',
    name: 'Uzbekistan'
  },
  {
    value: 'https://flatfy.vn',
    name: 'Vietnam'
  }
];

class CountrySelect extends React.Component {
  state = {
    selected: {
      name: '',
      value: ''
    }
  };

  handleChange = event => {
    this.setState({
      selected: event.target
    }, () => {
      window.location.href = this.state.selected.value;
    });
  };

  render() {
    const { selected } = this.state;

    return (
      <select value={selected.value}
              className={styles.countrySelect}
              onChange={this.handleChange}>
        {countries.map((item, index) =>
          <option key={index}
                  value={item.value}>
            {item.name}
          </option>
        )}
      </select>
    )
  }
}

export default CountrySelect;